import { render, staticRenderFns } from "./FastActive.vue?vue&type=template&id=54ad47b0&scoped=true"
import script from "./FastActive.vue?vue&type=script&lang=js"
export * from "./FastActive.vue?vue&type=script&lang=js"
import style0 from "./FastActive.vue?vue&type=style&index=0&id=54ad47b0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ad47b0",
  null
  
)

export default component.exports